<template>
  <loader v-if="offices === null" />
  <div v-else>
    <div class="bg-grey-lighter border" v-if="mode === 'edit'">
      <button class="px-2 py-3 bg-grey-lighter hover:bg-grey-light relative group" title="Office">
        <i class="fas fa-building fa-fw"></i>
        <i class="fas fa-caret-down"></i>
        <div class="bg-white absolute pin-l pin-t-full border rounded-b whitespace-no-wrap shadow hidden group-hover:block z-10 overflow-y-auto max-h-64">
          <div class="flex flex-col">
            <button v-for="office in offices" :key="office.id" class="border-b px-3 py-2 hover:bg-grey-lighter text-left" @click="localOfficeId = office.id">
              <i class="fas fa-check mr-2" :class="{ invisible: localOfficeId !== office.id }"></i> {{ office.address_town }}
            </button>
          </div>
        </div>
      </button>
    </div>

    <loader v-if="profiles === null" />
    <div v-else-if="profiles.length === 0" class="bg-yellow-lighter text-yellow-darker p-3 rounded m-3">
      <i class="fas fa-exclamation-triangle"></i> There are no team profiles configured for this office. View the staff tab on the profiles section of the members hub to get started.
    </div>

    <div v-else class="container mx-auto text-center p-6">
      <h2 class="text-3xl">Meet the {{ office ? office.address_town : '' }} Team</h2>
      <div class="flex flex-wrap justify-center">
        <div v-for="profile in profiles" :key="profile.id" class="w-full sm:w-1/2 lg:w-1/3 xl:w-1/4 p-6 flex flex-col items-center">
          <img v-if="profile.large_uploaded_photo_url" :src="profile.large_uploaded_photo_url" class="w-48 h-48 rounded-full object-cover object-center mb-6" />
          <div v-else class="w-48 h-48 rounded-full bg-grey-lighter flex items-center justify-center mb-6">
            <i class="fas fa-user text-5xl"></i>
          </div>
          <p>{{ profile.first_name }} {{ profile.surname }}</p>
          <p class="text-sm">{{ profile.position }}</p>
          <div class="flex mt-3" v-if="profile.social_media">
            <div v-if="profile.social_media.facebook"  :class="socialClass" title="Facebook">
              <i class="fab fa-facebook-f fa-fw"></i>
            </div>
            <div v-if="profile.social_media.twitter" :class="socialClass" title="X">
              <i class="fas fa-times fa-fw"></i>
            </div>
            <div v-if="profile.social_media.instagram" :class="socialClass" title="Instagram">
              <i class="fab fa-instagram fa-fw"></i>
            </div>
            <div v-if="profile.social_media.tiktok" :class="socialClass" title="Tiktok">
              <i class="fab fa-tiktok fa-fw"></i>
            </div>
            <div v-if="profile.social_media.youtube" :class="socialClass" title="YouTube">
              <i class="fab fa-youtube fa-fw"></i>
            </div>
            <div v-if="profile.social_media.linkedin" :class="socialClass" title="LinkedIn">
              <i class="fab fa-linkedin fa-fw"></i>
            </div>
            <div v-if="profile.social_media.pinterest" :class="socialClass" title="Pinterest">
              <i class="fab fa-pinterest fa-fw"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  props: {
    value: Object,
    officeId: Number,
    mode: String
  },
  data () {
    return {
      localOfficeId: this.officeId,
      offices: null,
      profiles: null,
      socialClass: 'w-10 h-10 mx-1 rounded-full flex items-center justify-center bg-grey-lighter hover:bg-grey-lighter text-black dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white'
    }
  },
  computed: {
    ...mapState(['selectedOffice']),
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    office () {
      if (!this.offices) {
        return
      }

      return this.offices.find((o) => o.id === this.localOfficeId)
    }
  },
  created () {
    this.getOffices()
  },
  methods: {
    getOffices () {
      v2Api.get('office', {
        params: {
          client_id: this.selectedOffice.client_id,
          limit: 50
        }
      }).then((response) => {
        this.offices = response.data.data

        if (!this.offices.find((o) => o.id === this.localOfficeId) && this.offices.length > 0) {
          this.localOfficeId = this.offices[0].id
          return
        }

        this.getProfiles()
      })
    },
    getProfiles () {
      if (!this.localOfficeId) {
        return
      }

      this.profiles = null
      v2Api.get(`/office/${this.localOfficeId}/profiles`).then((response) => {
        this.profiles = response.data
      })
    }
  },
  watch: {
    localOfficeId: {
      handler () {
        this.$emit('office-changed', this.localOfficeId)
        this.getProfiles()
      }
    }
  }
}
</script>
